import styled from 'styled-components/macro';
import { Col, Container, Row } from '@yme/atoms/grid';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
export const CardColDesktopStyled = styled(Col) `
  position: relative;

  z-index: ${Z_INDEX.level1};

  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-left: -50%;' : 'margin-right: -50%;')}
`;
export const CardRowStyled = styled(Row) `
  justify-content: center;
`;
export const PromoCardContainerStyled = styled(Container) `
  margin: -32px 0 0;
  position: relative;
  padding: 0 0 ${INDENT.xxl};
  z-index: ${Z_INDEX.level1};
`;
export const PromoDesktopRowStyled = styled(Row) `
  align-items: center;
  justify-content: space-between;
`;
